import { all } from 'redux-saga/effects';
import chatSagas from './chat/saga';
// import authSagas from './auth/saga';

export default function* rootSaga(socket) {
  yield all([
    chatSagas(socket)
  ]);
}
